<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印电阻产品标"
      class="materialCodeModal"
      width="500px"
      top="5vh">
    <!--    80*40-->
    <div id="labelSettings">
      <el-form :inline="true" label-width="140px">
        <el-form-item label="LOGO">
          <el-checkbox v-model="logoVisible"/>
        </el-form-item>
        <el-form-item label="规格型号">
          <el-input v-model="printType"/>
        </el-form-item>
        <el-form-item label="数量">
          <el-input v-model="printQty"/>
        </el-form-item>
        <el-form-item label="条码">
          <el-input v-model="barCodeText">
            <el-button type="primary" slot="append" @click="codeChange">重新生成</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <el-divider/>
    <div id="labelContent2a1">
      <div v-for="(productInfo,index) in productInfos" :key="index" id="printMaterialBoxLabel2a1">
        <img style="width: 60px;height: 12px;" v-if="logoVisible" :src="logoSrc">
        <div style="margin:0px 5px 0px 5px;text-align: center;">
          <div style="font-size: 10px;font-family: 'Arial Narrow';font-weight: bold;letter-spacing: -0.5px;margin-top: -5px;" v-if="logoVisible">
            {{printType}}
          </div>
          <div style="font-size: 12px;font-family: 'Arial Narrow';font-weight: bold;letter-spacing: -0.3px;" v-else>{{printType}}</div>
          <div style="height: 12px;">
            <img style="width:100%;height:12px;" :id="(() => 'barCode2a1_'+productInfo.pkid)()">
          </div>
          <div style="font-size: 9px;font-weight: bold;margin-top: 2px;">{{productInfo.text}}</div>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import JsBarcode from "jsbarcode";
  import moment from "moment";

  export default {
    data() {
      return {
        dialogVisible: false,
        logoVisible: true,
        printType: "",
        printQty: "",
        printName: "",
        productInfo: {},
        productInfos: [],
        logoSrc: "",
        barCodeText: "",
        printOption: {
          id: "labelContent2a1",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
      };
    },

    methods: {
      open(productInfo) {
        this.logoSrc = "../../../../img/se/print_logo.png";
        this.dialogVisible = true;
        this.productInfo = productInfo;
        this.printType = this.productInfo.specification;
        this.printDate = this.productInfo.planStartTime;
        this.printQty = this.productInfo.quantity;
        this.barCodeText = moment(new Date(this.printDate)).format("YYMMDD") + this.productInfo.productionOrderNo.substring(this.productInfo.productionOrderNo.length - 4) + "001";

        this.setBarcode(1);

        // this.$nextTick(() => {
        //   document.getElementById("barCode3a1_" + this.productInfo.pkid).innerHTML = "";
        //   this.bindBarCode(this.barCodeText, this.productInfo.pkid);
        // });
      },
      setBarcode(baseNum) {
        this.productInfos=[];
        for (var i = 0; i < this.printQty; i++) {
          // let text = moment(new Date(this.printDate)).format("YYMMDD")
          let text = this.barCodeText.substring(0, 6)
              + this.productInfo.productionOrderNo.substring(this.productInfo.productionOrderNo.length - 4)
              + (parseInt(baseNum) + i).toString().padStart(3, "0");
          let info = {
            pkid: text,
            text: text,
          };
          this.productInfos.push(info);
          this.$nextTick(() => {
            document.getElementById("barCode2a1_" + text).innerHTML = "";
            this.bindBarCode(text, text);
          });
        }
      },


      bindBarCode(row, id) {
        let text = row;
        new JsBarcode(document.getElementById("barCode2a1_" + id), row, {
          text: text,
          // fontSize: 18,
          width: 4,
          height: 15,
          margin: 0,
          displayValue: false,
          // fontOptions: "bold",
        });
      },
      codeChange() {
        // this.$nextTick(() => {
        // document.getElementById("barCode3a1_" + this.productInfo.pkid).innerHTML = "";
        // this.bindBarCode(this.barCodeText, this.productInfo.pkid);
        // });
        this.productInfos = [];
        let t = this.barCodeText.substring(this.barCodeText.length - 3, this.barCodeText.length);
        this.setBarcode(t);
      },
    },
  };
</script>
<style lang="scss" scoped>
//.materialCodeModal .el-dialog__header {
//  position: fixed;
//  width: 100%;
//  top: 0;
//  z-index: 99999;
//  box-sizing: border-box;
//}
//
//.materialCodeModal .el-dialog__footer {
//  position: fixed;
//  width: 100%;
//  bottom: 0;
//  z-index: 99999;
//  box-sizing: border-box;
//  background-color: #fff;
//}
//
////.materialCodeModal .el-dialog {
////  margin: 2% auto !important;
////  transform: scale3d(1, 1, 1);
////  padding-top: 30px;
////  padding-bottom: 39px;
////  height: 100%;
////}
//
//.materialCodeModal .el-divider--horizontal {
//  margin: 0px 0;
//}
//
//.materialCodeModal .el-dialog .el-dialog__body {
//  height: 100%;
//  background-color: #fff;
//  overflow: scroll;
//}
</style>

<style lang="scss" scoped>
#printMaterialBoxLabel2a1 {
  width: 35mm;
  height: 15mm;
  margin: 0 auto;
  //margin-top: 5px;
  //margin-bottom: 0px;
  page-break-before: always;
  //font-size: 10px;
  //display: flex;
  align-items: center;
}
</style>
